import styled from 'styled-components'
import PropTypes from 'prop-types'

const FilterWrapper = styled.div`
  margin-bottom: 20px;
`

const FilterTitle = styled.h2`
  font-weight: bold;
  font-size: 14px;
  margin-bottom: 10px;
`

const FilterList = styled.div`
  display: flex;
  flex-direction: column;
`

const FilterItemLabel = styled.label`
  font-weight: normal;
  font-size: 14px;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  cursor: pointer;
  justify-content: space-between;
  width: 100%;
`

const Radio = styled.input.attrs({ type: 'radio' })`
  margin-right: 8px !important;
`

const FilterItem = ({ title, options, selected, onChange }) => {
  const handleRadioClick = value => {
    if (selected === value) {
      onChange('')
    } else {
      onChange(value)
    }
  }
  return (
    <FilterWrapper>
      <FilterTitle>{title}</FilterTitle>
      <FilterList>
        {options.length > 0 &&
          options.map(
            option =>
              option.key && (
                <FilterItemLabel key={option.key}>
                  <Radio
                    name={title}
                    value={option.key}
                    checked={selected === option.key}
                    onClick={() => handleRadioClick(option.key)}
                    readOnly
                  />
                  <span style={{ flex: 1, textAlign: 'left' }}>
                    {option.key}
                  </span>
                  <span
                    style={{ minWidth: 40, textAlign: 'right', color: '#888' }}
                  >
                    {option.doc_count}
                  </span>
                </FilterItemLabel>
              )
          )}
      </FilterList>
    </FilterWrapper>
  )
}

FilterItem.propTypes = {
  title: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string,
      doc_count: PropTypes.number
    })
  ).isRequired,
  name: PropTypes.string.isRequired,
  selected: PropTypes.string,
  onChange: PropTypes.func.isRequired
}

export default FilterItem
